import React from "react";

const Volver = () => {
  const handleBack = () => {
    window.history.back(); // Vuelve a la página anterior en el historial del navegador
  };

  return (
    <button
      onClick={handleBack}
      className="fixed bottom-5 right-5 bg-green-900 p-4 rounded-xl text-textoClaro font-bold text-lg hover:bg-green-600 shadow-lg shadow-green-500/50"
    >
      Volver
    </button>
  );
};

export default Volver;
